import { render } from "./ParterC.vue?vue&type=template&id=ed6074b6"
import script from "./ParterC.vue?vue&type=script&lang=js"
export * from "./ParterC.vue?vue&type=script&lang=js"

import "./ParterC.vue?vue&type=style&index=0&id=ed6074b6&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__